
import {Component, Mixins, Prop, Ref} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";

@Component({
  components: { DatabasePicker },
})

export default class DokumanTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() action!: string;
  @Prop() returnId!: boolean;
  @Prop() rules!: string;
  @Prop() context!: string; // opsiyonel manuel context
  @Ref('databasePicker') readonly databasePicker!: DatabasePicker;

  get computedAction() {
    const base = this.action && this.action !== '' ? this.action : '/api/v1/dokuman-turu';
    const ctx = this.resolveContext();
    if (!ctx) return base;

    if (base.includes('/filter')) {
      if (base.includes('context=')) return base;
      const sep = base.includes('?') ? '&' : '?';
      return `${base}${sep}context=${ctx}`;
    }

    return `${base}/filter?context=${ctx}`;
  }

  private resolveContext(): string | null {
    if (this.context) return this.context;
    const path: string = (this as any).$route?.path || '';

    if (path.includes('/icrapro/takip-ekle') || path.includes('/icrapro/takip-detay') || path.includes('/api/v1/takip')) {
      return 'takip_dosya';
    }

    if (path.includes('/ofispro/vekalet') || path.includes('/ofispro/muvekkil')) {
      return 'muvekkil';
    }

    try {
      const ap = (this as any).$store?.state?.activeProcesses || [];
      const last = ap.length > 0 ? ap[ap.length - 1] : null;
      const key = last?.key;
      if (key === 'takip-ac' || key === 'takip-duzenle') return 'takip_dosya';
      if (key === 'muvekkil-detay' || key === 'vekalet-detay') return 'muvekkil';
    } catch (e) { /* ignore */ }

    return null;
  }

  load() {
    this.databasePicker.load();
  }
}
